<template>
	<b-modal id="modal-editCursoCertificado" @show="resetModal" @ok="handleEnvio">
		<template v-slot:modal-title>
			<label>Cambiar asignacion certificado</label>
		</template>
		<b-alert 
			show 
			variant="warning"
			>
			No olvides que solo mostrará los cursos que tienes asignados
		</b-alert>
		<b-form-group label="Selecciona el curso">
			<v-select
				:options="jsonCurso"
				label="tituloCurso"
				v-model="selectCurso"
				@input="changeModulo()"
			>
			</v-select>
		</b-form-group>
		<b-form-group label="Selecciona el modulo">
			<b-form-select
				v-model="selectModulo"
				:options="optionModulo"
				:disabled="booleanModulo"
			>
			</b-form-select>
		</b-form-group>
		<template v-slot:modal-footer="{ ok, cancel }">
			<b-button @click="cancel()">
				Cancelar
			</b-button>
			<b-button variant="primary" @click="ok()">
				Aceptar
			</b-button>
		</template>
		<toast ref="toast"/>
	</b-modal>
</template>
<script>
import { mapState, mapActions } from "vuex";
import certificado from "../../../store/modules/certificado";
import toast from "@/components/toastComponent";
export default {
	components:{
		toast
	},
	data() {
		return {
			selectCurso: "",
			selectModulo: null,
			optionModulo: [],
			booleanModulo: true,
			certificado: {
				idCertificado:null,
				idInstanciaCertificado: null,
				nombre: null,
				contenido: null,
				imgCabecera: null,
				imgPiePagina: null
			}
		};
	},
	computed: {
		...mapState("certificado", ["jsonCertificado"]),
		...mapState("certificado", ["jsonInstanciaCertificado"]),
		...mapState("curso", ["jsonCurso"])
	},
	methods: {
		handleEnvio(bvModalEvt) {
			// Prevent modal from closing
			bvModalEvt.preventDefault();

			this.updateCursoInstancia();
		},
		resetModal() {
			this.selectModulo = "";
		},
		updateCursoInstancia() {
			const form = {
				idInstanciaCertificado: this.certificado.idInstanciaCertificado,
				idCurso: this.selectCurso.idCurso,
				idModulo: this.selectModulo
			};
			this.axios.put("api/updataCursoInstancia", form).then(res => {
				const arrayToast = {
						msg: "",
						title: "",
						variant: ""
				};

				if (res.data.msg == "cursoActualizado") {
					const getModulo = this.optionModulo.find(
						elem => elem.value == this.selectModulo
					);
					const certificado = this.jsonCertificado.find(
							elem =>
								elem.idCertificado ==
								this.certificado.idCertificado
					);
					const curso = certificado.curso.find(
						elem=>
							elem.idInstanciaCertificado ==
							this.certificado.idInstanciaCertificado
					);

					curso.idCurso = this.selectCurso.idCurso;
					curso.tituloCurso = this.selectCurso.tituloCurso;
					curso.idModulo = this.selectModulo;
					curso.nombre = this.selectModulo ? getModulo.text : null 

					arrayToast.msg = "Se ha actualizado el curso con exito"
					arrayToast.title = "Actualizacion curso certificado"
					arrayToast.variant = "success"
				}
				
				this.$refs.toast.makeToast(arrayToast);

			});  
		},
		changeModulo() {
			this.getModuloCurso(this.selectCurso.idCurso);
			this.booleanModulo = false;
		},
		getInfoModal(arrayOpcion) {
			this.certificado.idCertificado = arrayOpcion.idCertificado;
			this.certificado.idInstanciaCertificado =
				arrayOpcion.idInstanciaCertificado;

			this.selectCurso = this.jsonCurso.find(
				elem => elem.idCurso == arrayOpcion.idCurso
			);

			if (arrayOpcion.idModulo != null) {
				this.getModulos(arrayOpcion);
				this.booleanModulo = false;
			} else {
				this.booleanModulo = true;
			} 
		},
		getModulos(valueInstancia) {
			this.axios
				.get("api/getTotalModulos/" + valueInstancia.idCurso)
				.then(res => {
					const modulos = res.data.modulos;
					this.optionModulo = modulos.map(elem => ({
						value: elem.idModulo,
						text: elem.nombre
					}));

					const moduloCurso = this.optionModulo.find(
						elem => elem.value == valueInstancia.idModulo
					);

					this.selectModulo = moduloCurso.value;
				})
				.catch(err => console.log(err));
		},
		getModuloCurso(idCurso) {
			this.axios
				.get("api/getTotalModulos/" + idCurso)
				.then(res => {
					const listadoModulos = res.data.modulos;
					const modulos = [
						{ value: null, text: "Haz click para seleccionar un modulo." }
					];
					listadoModulos.map(elem =>
						modulos.push({ value: elem.idModulo, text: elem.nombre })
					);
					this.optionModulo = modulos;
					this.selectModulo = this.optionModulo[0].value;
				})
				.catch(err => console.log(err));
		}
	}
};
</script>
